export default __webpack_public_path__ + "static/media/circle-right.24123696.svg";